(ns motorsaif.web.fx
  (:require
   [re-frame.core :as rf]
   [reagent.core :as r]
   [goog.net.Cookies :as gcookies]
   [motorsaif.string :refer [format]]
   [motorsaif.data-utils :as data-utils]
   ["react-toastify" :as toast]
   [motorsaif.log :as log]
   [motorsaif.time :as time]
   [ajax.core :refer [GET POST PUT DELETE] :as ajax]
   [reitit.frontend.easy :as rfe]))

(def cookies (gcookies/getInstance))


;; (.set cookies "locale" (name locale) (encore/secs :years 5) nil)

(rf/reg-fx :common/navigate-fx!
           (fn [[k & [params query]]]
             (rfe/push-state k params query)))

(rf/reg-fx :common/replace-url-state!
           (fn [[k & [params query]]]
             (rfe/replace-state k params query)))

(rf/reg-cofx ::cookie
             (fn [coeffects cookie-k]
               (assoc-in coeffects [:cookies cookie-k] (.get goog.net.cookies (name cookie-k)))))

(defonce interval-handler                ;; notice the use of defonce
  (let [live-intervals (atom {})]        ;; storage for live intervals
    (fn handler [{:keys [action id frequency event]}]     ;; the effect handler
      (condp = action
        :clean   (doall                ;; <--- new. clean up all existing
                  (map #(handler {:action :end  :id  %1}) (keys @live-intervals)))
        :start   (swap! live-intervals assoc id (js/setInterval #(rf/dispatch event) frequency))
        :end     (do (js/clearInterval (get @live-intervals id))
                     (swap! live-intervals dissoc id))))))

(when interval-handler
  (interval-handler {:action :clean}))

(rf/reg-fx :interval interval-handler)

(defn do-ajax [{:keys [type id error-handler url handler params opts form-data progress-handler finally] :as args}]
  ;; (log/info [:ajax url :id id])
  (let [req-fn (condp = type
                 :GET GET
                 :PUT PUT
                 :DELETE DELETE
                 :POST POST)
        opts (if (some #{:POST :DELETE :PUT} [type])
               (assoc-in opts [:headers "x-csrf-token"] js/csrfToken)
               opts)
        handler (fn [res]
                  (rf/dispatch [:assoc-data [:ajax-status id :fetched] (time/stamp)])
                  (cond (fn? handler)     (handler res)
                        (vector? handler) (rf/dispatch (conj handler res))))

        req-opts (-> {:error-handler
                      (fn [{:keys [status status-text] :as res}]
                        (log/error "Got error" res)
                        (rf/dispatch [:assoc-data [:ajax-status id :error]
                                      {:time (time/stamp)
                                       :response res}])
                        (when error-handler
                          (error-handler res)))}
                     (cond-> opts


                       (merge opts))
                     (data-utils/assoc-if-val :body form-data)
                     (data-utils/assoc-if-val :progress-handler progress-handler)
                     (data-utils/assoc-if-val :finally finally)
                     (data-utils/assoc-if-val :params params)
                     (assoc :handler handler))]
    (req-fn url req-opts)))

(rf/reg-fx :ajax do-ajax)

;; Ajax life cycle:
;; dispatch event ->
;; interceptor before ->
;; event-fn processed ->
;; interceptor after ->
;; do-ajax fx handler (request now in flight) ->

;; On success
;; success-handler

;; On error
;; success-handler processed

;; (def require-verified-user
;;   (rf/->interceptor
;;    :id     :require-user
;;    :after  (fn [{:keys [coeffects effects] :as context}]
;;              (let [{:keys [db original-event]} coeffects
;;                    user-id (get-in db [:user :db/id])]
;;                (if user-id
;;                  context
;;                  (assoc context :effects {}))))))

(def require-user
  (rf/->interceptor
   :id     :require-user
   :after  (fn [{:keys [coeffects] :as context}]
             (let [{:keys [db]} coeffects
                   user-id (get-in db [:user :db/id])]
               (if user-id
                 context
                 (assoc context :effects {}))))))


(rf/reg-event-db ::toast
  (fn [db [_ {:keys [title message type opts id
                     auto-close timeout
                     position
                     close-on-click
                     buttons draggable]
              :or {type "neutral"
                   position "top-center"
                   id (str (gensym "toast"))
                   draggable true
                   close-on-click true}
              :as args}]]

    (let [auto-close (if (= auto-close nil)
                       (or timeout 4000)
                       auto-close)
          type (name type)
          ;; draggable (or (when (seq buttons) false) draggable)
          render (cond
                   (and message title)
                   (fn [r]
                     (let [id ^js (.-toastProps.toastId r)]
                       (r/as-element [:div.toast-notification
                                      [:div.title title]
                                      [:div.msg
                                       message
                                       (when buttons
                                         (into [:div.toast-actions]
                                               (map (fn [{:keys [title click class]}]
                                                      [:button.btn.primary
                                                       {:class class
                                                        :on-click (fn [e]
                                                                    (.preventDefault e)
                                                                    (log/info "title" title)

                                                                    ;; Close fn
                                                                    (click #((.-toast.dismiss toast) id))
                                                                    )}
                                                       title])
                                                    buttons)))]
                                      ])))
                   (string? message) message
                   message (r/as-element message))
          toast-fn (case type
                     "neutral" (.-toast toast)
                     "success" (.-toast.success toast)
                     "info" (.-toast.info toast)
                     "loading" (.-toast.loading toast)
                     "error" (.-toast.error toast)
                     "warn" (.-toast.warn toast))

          ?existing-toast-id (get-in db [:ui-state :toasts id])

          opts (-> {:position position
                    ;; :position "bottom-right"
                    :autoClose auto-close
                    :closeOnClick close-on-click
                    :pauseOnFocusLoss false
                    :draggable draggable
                    :type type
                    :pauseOnHover false
                    :onClose (when id
                               (fn [_]
                                 (rf/dispatch [:set-ui-state :toasts #(dissoc % id)])))}
                   (cond-> (not ?existing-toast-id) (assoc :hideProgressBar true)
                           ?existing-toast-id (assoc :isLoading false)
                           opts (merge opts)))

          js-options (clj->js opts)

          toast-id (if ?existing-toast-id
                     ((.-toast.update toast) ?existing-toast-id js-options)
                     (toast-fn render js-options))]

      (if (and toast-id id)
        (assoc-in db [:ui-state :toasts id] toast-id)
        db))))

(defn do-toast [args]
  (rf/dispatch [::toast args]))

;; (.-defaultProps toast)

(comment
  (do-toast {:message "hi"
             :title "hey"}))

(rf/reg-fx :toast do-toast)

;; ((.-toast.info) toast "d")

;; (toast "hey")
;; (.-toast.toast) toast "d")
;; (.-toast.error)

(comment
  (rf/dispatch [:toast {:type "warn"
                        :auto-close false
                        :draggable false
                        :position "bottom-center"
                        :close-on-click false
                        :title "Get Notified"
                        :buttons [{:title "Reload"
                                   :click (fn [close]
                                            (log/info "Yes")
                                            (close))}]
                        :message "In order notify you for your requests, please enable alerts."}])

  (rf/dispatch [:toast {:type "warn"
                        :auto-close false
                        :draggable false
                        :close-on-click false
                        :title "Update"
                        :buttons [{:title "Reload"
                                   :click (fn [close]
                                            (log/info "Yes")
                                            (close))}]
                        :message "MotorSaif has been updated. Click to reload."}])

(rf/dispatch [:toast {:type "error"
                      :auto-close false
                      :draggable false
                      :close-on-click false
                      :title "title"
                      :buttons [{:title "Yes"
                                 :click (fn [close]
                                          (log/info "Yes")
                                          (close))}
                                {:title "no"
                                 :click (fn [] (log/info "no"))}]
                      :message "Pleaese enable notifications manually in your settings."}]))
